import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field, getFormValues } from "redux-form";
import { TimeInput } from "../../common/TimeInput";
import DateTimeField from "../../common/DateTimeField";
import { WideField } from "../../common/Inputs";
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { updateSettings } from "../../../actions/settings";
import { parseTime } from "../../../extensions/dateHelper";
import { defaultWorkTime } from '../../../constants/settingTypes';
import moment from "moment";
const validate = (values) => {
    const { PickupStartTime, PickupEndTime, OffloadStartTime, OffloadEndTime, Date: date, IsWeekend } = values;
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }
    if (IsWeekend) {
        required('Date');

        if (date <= new Date())
            errors.Date = "*Некорректная дата";

        return errors;
    }

    Object.keys(values).filter(k => k !== 'IsWeekend').forEach(required);

    if (Object.keys(errors).length > 0 || Object.keys(values).length === 0)
        return errors;

    if (parseTime(PickupStartTime) >= parseTime(PickupEndTime))
        errors._error = "*Конец времени для приема вещей больше начала";

    if (parseTime(OffloadStartTime) >= parseTime(OffloadEndTime))
        errors._error = "*Конец времени для доставки вещей больше начала";

    if (date <= new Date())
        errors.Date = "*Некорректная дата";

    return errors;
}

let ScheduleAddModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }
    _onSubmit(values) {
        if (values.IsWeekend) {
            values.OffloadStartTime = values.OffloadEndTime = values.PickupEndTime = values.PickupStartTime = "00:00";
        }
        const timeZoneOffset = new Date().getTimezoneOffset() / 60;
        values.Date = moment(values.Date).add(-timeZoneOffset, 'hours').toDate();
        values.PickupStartTime = moment(values.PickupStartTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        values.PickupEndTime = moment(values.PickupEndTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        values.OffloadStartTime = moment(values.OffloadStartTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        values.OffloadEndTime = moment(values.OffloadEndTime, 'HH:mm').add(timeZoneOffset, 'hours').format('HH:mm');
        this.props.updateSettings('schedule', values);
    }
    render() {
        const { fetching, onClose, handleSubmit, anyTouched, error, isWeekend, crudError, initialValues: { Date } } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Время работы</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal'>

                        <Field name="Date" component={DateTimeField} time={false} label='Дата' dateTimeFormat='DD-MM-YYYY' min={Date} />
                        <div className="form-group">
                            <label className="control-label col-sm-3">Прием вещей</label>
                            <div className="controls col-sm-9 row">
                                <div className="col-sm-5">
                                    <Field name='PickupStartTime' component={TimeInput} disabled={isWeekend} />
                                </div>
                                <div className="col-sm-2">
                                    <hr style={{ borderTop: '1px solid black', marginTop: '17px' }} />
                                </div>
                                <div className="col-sm-5">
                                    <Field name='PickupEndTime' component={TimeInput} disabled={isWeekend} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-3">Возврат вещей</label>
                            <div className="controls col-sm-9 row">
                                <div className="col-sm-5">
                                    <Field name='OffloadStartTime' component={TimeInput} disabled={isWeekend} />
                                </div>
                                <div className="col-sm-2">
                                    <hr style={{ borderTop: '1px solid black', marginTop: '17px' }} />
                                </div>
                                <div className="col-sm-5">
                                    <Field name='OffloadEndTime' component={TimeInput} disabled={isWeekend} />
                                </div>
                            </div>
                        </div>

                        <Field name="IsWeekend" component={WideField} type='checkbox' label="Выходной" />
                        {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                    </form>}
                    {fetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {crudError && <p>{crudError}</p>}
                    </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

ScheduleAddModal = reduxForm({
    form: 'scheduleEdit',
    validate
})(ScheduleAddModal);

ScheduleAddModal = connect(state => {
    const formValues = getFormValues('scheduleEdit')(state);
    const initialDate = new Date();
    initialDate.setDate(initialDate.getDate() + 1);
    return {
        fetching: state.application.get("settings").schedule.updateFetching,
        initialValues: {
            Date: initialDate,
            IsWeekend: false,
            ...state.application.get("settings")[defaultWorkTime].data
        },
        isWeekend: formValues && formValues.IsWeekend,
        crudError: state.application.get('settings').schedule.updateError
    }
}, { updateSettings })(ScheduleAddModal);

export default ScheduleAddModal;


// WEBPACK FOOTER //
// ./src/components/settings/schedule/ScheduleAddModal.jsx